export function arrayToCsv<T extends Record<string, any>>(data: T[]): string {
  if (!data.length) return '';
  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','),
    ...data.map(row =>
      headers
        .map(h => `"${((row as Record<string, any>)[h] ?? '').toString().replace(/"/g, '""')}"`)
        .join(',')
    ),
  ];
  return csvRows.join('\n');
}
